<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <el-form ref="queryForm"
                         :model="queryParams"
                         :inline="true"
                         label-width="80px">
                    <el-row class="mt15 mb10">
                        <el-col :span="6" class="mb0">
                            <el-form-item label="成果类型">
                                <el-select clearable @change="pageList()" v-model="queryParams.achieveType" placeholder="请选择">
                                    <el-option v-for="item in achieveTypeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">

                        </el-col>
                        <el-col :span="12" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.achieveTitle" placeholder="请输入名称" class="input-with-select">
                                    <template #append>
                                        <el-button @click="pageList" type="primary" style="background-color: #3b62f8;color: #fff"  icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="right-container">
                <div class="achieve-list">
                    <div class="achieve-item" @click="viewInfo(item)" v-for="item in dataList" :key="item">
                        <div class="achieve-cover">
                            <img class="img-100"  :src="item.coverUrl" alt />
                        </div>
                        <div class="achieve-type-title">
                            <div class="achieve-type">{{item.achieveTypeName}}</div>
                            <div class="achieve-name">{{item.achieveTitle}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="dataList&&dataList.length===0">
                        <dataEmpty title="暂无成果" />
                    </div>
                </div>
                <div class="page-container" style="padding-bottom: 10px" v-if="dataList&&dataList.length>0">
                    <pageTag :background="true"
                             :pageSizes="[8, 12, 16]"
                             v-show="total > 0"
                             :total="total"
                             v-model:page.sync="queryParams.pageNum"
                             v-model:limit.sync="queryParams.pageSize"
                             @pagination="pageList" />
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <achieve-info :info-id="this.infoId"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import achieveInfo from "@/components/teachResearch/achieveInfo.vue";
import {achievePage} from "@/api/admin/achieve";

export default {
    name:'pageCourse',
    components:{achieveInfo, pageTag, dataEmpty},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
            this.pageList();
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
    },
    mounted() {
        if (this.$store.state.params.jumpParams.achieveId){
            this.infoId = this.$store.state.params.jumpParams.achieveId;
            this.showMode = "detail"
            this.$emit('change-mode',this.showMode);
        }
        this.getQueryDict();
        this.pageList();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            timestampToTime,
            itemName:'课题引领',
            itemKey:'',
            queryParams: {
                achieveTitle: '',
                achieveType: '',
                pageNum: 1,
                pageSize: 8,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            infoId:'',
            natureList:[],
            achieveTypeList: [],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'achieve_type' }).then(res => {
                this.achieveTypeList = res.data.data;
            })
        },
        pageList(){
            achievePage(this.queryParams).then(res => {
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
                this.pageCount = res.data.data.totalPage;
            });
        },
        viewInfo(item){
            this.showMode = "detail"
            this.infoId = item.achieveId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.form-box{
    width: 98%;
    height: auto;
    margin: auto;
    background-color: #fff;
    padding-top: 5px;
}
.right-container{
    width: 100%;
    height: auto;
}


/deep/ .head-name{
    background-color: #6e99c8!important;
    color: #fff;
    font-size: 15px;
}

.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
}
.detail-mode{
    width: 100%;
    height: auto;
}

/*成果*/
.achieve-box{
    width: 96%;
    height: auto;
    margin: auto;
    background-color: #fff;
    padding-bottom: 10px;
    margin-top: 20px;
}
.achieve-list{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-left: 4px;
    padding-bottom: 10px;
    align-items: center;
}
.achieve-item{
    width: 25%!important;
    height: 220px;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    //box-shadow: var(--el-box-shadow-light);
}
.achieve-cover{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-type-title{
    display: flex;
    height: 30px;
    width: 100%;
    margin-top: 10px;
}
.achieve-type{
    height: 20px;
    width: 40px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 20px;
    background-color: #3b62f8;
    border-radius: 4px;
}
.achieve-name{
    height: 20px;
    width: calc(100% - 40px);
    color: #333;
    font-size: 16px;
    text-align: left;
    line-height: 20px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-indent: 5px;
}
</style>